import {
  extractSiteIdFromSearch,
  getCurrentSearchString,
} from 'utils/routing/urlHelpers'
import { findMatchingLessonNode } from 'utils/lms/lessonNodeHelpers'

export { resolveIndexBasedLeafNodeId } from 'utils/courseTreeHelpers'

export const resolveSiteId = ({
  explicitSiteId,
  userContext,
  locationSearch,
} = {}) => {
  if (explicitSiteId != null) return explicitSiteId
  const fromContext = userContext?.sites?.[0]?.siteId
  if (fromContext != null) return fromContext
  const search = locationSearch || getCurrentSearchString()
  return extractSiteIdFromSearch(search)
}

export const getLessonCompletionState = ({
  registrations,
  registrationId,
  courseNodeId,
  leafNodeId,
}) => {
  const defaultState = { isComplete: false, completedAt: null }
  if (!Array.isArray(registrations) || (!courseNodeId && !leafNodeId)) {
    return defaultState
  }

  const match =
    registrationId != null
      ? registrations.find(
          reg => String(reg.registration_id) === String(registrationId),
        )
      : null
  if (!match || !Array.isArray(match.lesson_nodes)) return defaultState

  const node =
    findMatchingLessonNode(match.lesson_nodes, courseNodeId) ||
    (leafNodeId
      ? match.lesson_nodes.find(n => n.leaf_node_id === leafNodeId)
      : null)

  return node
    ? { isComplete: !!node.is_done, completedAt: node.done_at || null }
    : defaultState
}
